<div class="d-flex flex-column">
  <div class="btn-group filters" [style.justify-content]="position">
    <ng-container *ngTemplateOutlet="filterDefinitions && filterDefinitions.length > 0 ? filterTemplate : ''">
    </ng-container>
    <ng-container *ngTemplateOutlet="typeAheadDefinitions ? typeAhead : ''">
    </ng-container>
    <div ngbDropdown class="btn-group" *ngIf="range">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{'Range' | translate}}: {{dateFilter.selected_type | translate}}
      </button>
      <div ngbDropdownMenu>
        <button
          *ngFor="let type of dateTypes"
          [ngClass]="[
            'dropdown-item',
            dateFilter.selected_type === type ? 'selected' : 'not-selected'
          ]"
          (click)="dateFilter.selected_type = type; timeTravels('');">
          <span>{{type | translate}}</span>
        </button>
      </div>
    </div>
    <div ngbDropdown [autoClose]="'outside'" class="btn-group" *ngIf="typeFilters">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{typeFilters.name | translate}}: {{typeFilters.selected_type | translate}}
      </button>
      <div ngbDropdownMenu>
        <button *ngFor="let filter of typeFilters.filter_types"
                class="dropdown-item d-flex justify-content-between align-items-center"
                (click)="typeFilters.selected_type = filter; selectedFilterChanged()">
          <span>{{filter | translate}}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="arrow-buttons" *ngIf="dateFilter.selected_type !== 'All'"  style="width: 100%;">
    <div class="date-button">
      <a class="link" style="margin: auto;" (click)="timeTravels('previous')">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#left"></use>
        </svg>
      </a>
    </div>
    <div class="date-field">
      <span>{{startDate | date: 'dd.MM.yyyy'}} - {{endDate |  date: 'dd.MM.yyyy'}}</span>
    </div>
    <div class="date-button">
      <a class="link" style="margin: auto;" (click)="timeTravels('next')">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#right"></use>
        </svg>
      </a>
    </div>
  </div>
</div>
<ng-template #filterTemplate>
  <ng-container *ngFor="let item of filterDefinitions; index as i">
    <div ngbDropdown class="btn-group" *ngIf="item.type === 'dropdown-single'">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{item.name | translate}}:
      </button>
      <div ngbDropdownMenu>
        <button *ngFor="let filter of item.filter_values"
                [ngClass]="[
                  'dropdown-item',
                  'd-flex',
                  'justify-content-between',
                  'align-items-center',
                  filter.boolean ? 'selected' : 'not-selected'
                ]"
                (click)="filter.boolean = true; dropDownType(i, filter)">
          <span>{{filter.name | translate}}</span>
        </button>
      </div>
    </div>
    <div ngbDropdown [autoClose]="'outside'" class="btn-group" *ngIf="item.type === 'dropdown-multiple'">
      <button ngbDropdownToggle class="btn btn-sm btn-outline-primary">
        {{item.name | translate}}: {{getActiveFilterCount(item.filter_values)}}
      </button>
      <div ngbDropdownMenu>
        <button *ngFor="let filter of item.filter_values"
                [ngClass]="[
                  'dropdown-item',
                  'd-flex',
                  'justify-content-between',
                  'align-items-center',
                  filter.boolean ? 'selected' : 'not-selected'
                ]"
                (click)="filter.boolean = !filter.boolean; selectedFilterChanged()">
          <span>{{filter.name | translate}}</span>
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #typeAhead>
  <ng-container *ngIf="typeAheadDefinitions">
    <input id="typeahead-format" type="text" class="form-control"
           [(ngModel)]="model"
           [placeholder]="placeholder || 'Search' | translate"
           (selectItem)="typeAheadEvent($event)"
           [inputFormatter]="formatter"
           [ngbTypeahead]="search"
           [resultTemplate]="rt"
           [resultFormatter]="formatter"/>
  </ng-container>
</ng-template>



<ng-template #rt let-r="result" let-t="term">
  <div class="d-flex justify-content-between">
    <ngb-highlight [result]="r.name" [term]="t.name">
      <a (click)="r.boolean = !r.boolean; selectedFilterChanged()"></a>
    </ngb-highlight>
  </div>
</ng-template>


<i class="fas fa-arrow-left" data-fa-symbol="left"></i>
<i class="fas fa-arrow-right" data-fa-symbol="right"></i>

